/** POS print / network / kitchen monitors feature reducers */
export async function loadPosPrintReducers() {
  const [
    printers,
    printerLocations,
    zones,
    posRouting,
    kitchenMonitors,
    backScreens,
    networkDiagram,
    receiptPrintSettings,
    orderPrintSettings,
    courseSettings,
    selfOrdering,
    selfOrderingMedia,
    selfOrderingMarketing,
  ] = await Promise.all([
    import('../reducers/PrintersReducer'),
    import('../reducers/PrinterLocationsReducer'),
    import('../reducers/ZonesReducer'),
    import('../reducers/PosRoutingReducer'),
    import('../reducers/KitchenMonitorsReducer'),
    import('../reducers/BackScreensReducer'),
    import('../reducers/NetworkDiagramReducer'),
    import('../reducers/ReceiptPrintSettingsReducer'),
    import('../reducers/OrderPrintSettingsReducer'),
    import('../reducers/CourseSettingsReducer'),
    import('../reducers/SelfOrderingReducer'),
    import('../reducers/SelfOrderingMediaReducer'),
    import('../reducers/SelfOrderingMarketingReducer'),
  ]);

  return {
    printers: printers.default,
    printerLocations: printerLocations.default,
    zones: zones.default,
    posRouting: posRouting.default,
    kitchenMonitors: kitchenMonitors.default,
    backScreens: backScreens.default,
    networkDiagram: networkDiagram.default,
    receiptPrintSettings: receiptPrintSettings.default,
    orderPrintSettings: orderPrintSettings.default,
    courseSettings: courseSettings.default,
    selfOrdering: selfOrdering.default,
    selfOrderingMedia: selfOrderingMedia.default,
    selfOrderingMarketing: selfOrderingMarketing.default,
  };
}
